export default function ProjectCard({ project }) {
  return (
    <div className="bg-white rounded-2xl shadow-sm hover:shadow-xl transition duration-500 overflow-hidden group">

      {/* Image */}
      <div className="h-48 overflow-hidden">
        <img
          src={project.image}
          alt={project.title}

          className="w-full h-full object-cover group-hover:scale-105 transition duration-500"
        />
      </div>

      {/* Content */}
      <div className="p-6">

        <h3 className="text-xl font-semibold text-slate-900 mb-2">
          {project.title}
        </h3>

        <p className="text-xs text-blue-600 mb-2 font-medium">
  {project.role}
</p>

        <p className="text-slate-600 text-sm leading-relaxed mb-4">
          {project.description}
        </p>

        {/* Tech stack */}
        <div className="flex flex-wrap gap-2 mb-4">
          {project.tech.map((tech, i) => (
            <span
              key={i}
              className="text-xs bg-slate-100 px-3 py-1 rounded-full text-slate-600"
            >
              {tech}
            </span>
          ))}
        </div>

        {/* Link */}
        <a
          href={project.link}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block text-sm font-medium text-blue-600 hover:underline"
        >
          View Live →
        </a>
      </div>
    </div>
  );
}